module.exports = __webpack_public_path__ + "static/media/tom.7eaa2daf.png";